import { styled } from 'styled-components'

const CIRCLE_SIZE = 14

interface DotProps {
  $isChecked: boolean
}

const StyledDot = styled.span<DotProps>`
  border-radius: ${(p) => p.theme.radiuses.rounded}px;
  background-color: ${({ theme }) => theme.colors.primary[500]};
  width: ${CIRCLE_SIZE}px;
  height: ${CIRCLE_SIZE}px;
  transform: scale(${(p) => (p.$isChecked ? 0.75 : 0)});
  transition: transform 0.1s ease-out;
  will-change: transform;
`

/** Small dot that animate itself */
const Dot: FC<DotProps> = ({ $isChecked = false }) => <StyledDot $isChecked={$isChecked} />

const OuterCircle = styled(Flex)<{
  $isChecked: boolean
  $isDisabled: boolean
  $isInvalid: boolean
}>`
  overflow: hidden;

  align-items: center;
  justify-content: center;

  width: ${CIRCLE_SIZE}px;
  height: ${CIRCLE_SIZE}px;

  border-radius: ${(p) => p.theme.radiuses.rounded}px;

  opacity: ${(p) => (p.$isDisabled ? 0.6 : 1)};

  border: 1px solid
    ${(p) =>
      p.$isInvalid
        ? p.theme.colors.feedback.error['500']
        : p.$isChecked
          ? p.theme.colors.primary[500]
          : p.theme.colors.grayscale[300]};

  transition: border-color 0.2s linear;
  will-change: border-color;
`

export interface RadioIndicatorProps {
  isChecked?: boolean
  isInvalid?: boolean
  isDisabled?: boolean
}

/** Shows whether the option is active or not */
const RadioIndicator: FC<RadioIndicatorProps> = ({
  isChecked = false,
  isDisabled = false,
  isInvalid = false
}) => {
  return (
    <OuterCircle $isDisabled={isDisabled} $isChecked={isChecked} $isInvalid={isInvalid}>
      <Dot $isChecked={isChecked} />
    </OuterCircle>
  )
}

export default RadioIndicator
